import { Injectable, ErrorHandler, Injector } from '@angular/core';
import { GlobalFlagsService } from './global-flags.service';
import { OAuthService } from './oauth.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

  private err;
  private globalFlagsService;
  private oAuthService;
  private dialogService;

  constructor(private injector: Injector) { }

  handleError(err: any) {
    console.error(err);
    if (!this.globalFlagsService) {
      this.globalFlagsService = this.injector.get(GlobalFlagsService);
    }
    this.err = err;
    this.globalFlagsService.displayLoad(false);
    this.globalFlagsService.setError(this.err);
    // this.err.error has the message -- this.err.status
    if (err.status === null) {
      // If no error -> API is failing.
      // Disconnect user
      if (!this.oAuthService) {
        this.oAuthService = this.injector.get(OAuthService);
      }
      this.oAuthService.logout();
    }
  }

}
